const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const addCommentApi = async (leadId, commentText, role) => {
  const token = localStorage.getItem('token');
  try {
    const response = await fetch(
      `${API_BASE_URL}/${role}/lead/leads/${leadId}/comments`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ comment: commentText }),
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(errorData?.message || 'Ошибка при добавлении комментария');
      error.errors = errorData?.errors;
      error.statusCode = response.status;
      throw error;
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при добавлении комментария:', error);
    throw error;
  }
};
